import { Stack, Typography } from "@mui/material";
import React from "react";
import { EventAudienceSvg } from "@onair/ui/svg/event-audience";

interface Props {
	showIcon?: boolean;
}

const DocHeader = ({ showIcon = true }: Props) => {
	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{showIcon && <EventAudienceSvg />}
			<Typography variant="subtitle1" flex={1}>
				Sự kiện dành cho ai?
			</Typography>
		</Stack>
	);
};

export default DocHeader;
